import constants from "../../constants";
import FavoriteButton from "../FavoriteButton";

interface IllustrationCardProps {
  illustration: any;
  selectionMode: boolean;
  selectedIllustrations: any[];
  toggleSelected: (event: any, illustration: any) => void;
  showConfigureIllustrationModal: (illustration: any, event: any) => void;
  isDesigner: boolean;
  privacyLabel: string;
  isFavorite?: boolean;
  toggleFavoriteCallback?: () => void;
}

export default function IllustrationCard({ illustration, selectionMode, selectedIllustrations, toggleSelected, showConfigureIllustrationModal, isDesigner, privacyLabel, isFavorite = false, toggleFavoriteCallback }: IllustrationCardProps) {

  return <div className={`component template ${selectionMode ? 'selection-mode' : ''}`} data-component={illustration.isSvg ? 'illustration' : 'image'}>
  <div className={`image ${illustration.isSvg ? "" : "ctr"}`} data-component={illustration.isSvg ? 'illustration' : 'image'} data-configuration={illustration.configuration}
       data-id={illustration.id}>
    {illustration.isSvg && <div className="img-wrap"><img src={illustration.thumbnailPath} alt={''}/></div>}
    {!illustration.isSvg && <img style={"width: 100%; height: 100%;"} src={illustration.thumbnailPath} alt={''}/>}
    <div className={'actions designer-actions ' + (isDesigner ? '' : 'hidden')}>
      <span>{privacyLabel}</span>
      <a className="icn" onClick={(event) => showConfigureIllustrationModal(illustration, event)}>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-cog"}/>
        </svg>
      </a>
      <div class="checkbox" onClick={(ev) => toggleSelected(ev, illustration)}>
        <input type="checkbox" checked={selectedIllustrations.includes(illustration)}></input>
      </div>
    </div>
    <FavoriteButton assetId={illustration.id} type="illustration" isFavorite={isFavorite} callback={toggleFavoriteCallback} />
  </div>
</div>

}
